module.exports = __webpack_public_path__ + "img/JapanIcon.9b9b3f6.png";